export default __webpack_public_path__ + "static/media/5.bea04a65.png";